import { toBoard } from './mappers/board';
import { toError } from './parsers';
import { decodeBoardId } from './utils';
export function initItem(settings, http) {
  /**
   * @summary Returns item
   * @memberof source.item
   * @param {String} itemId
   * @param {Object} [options]
   * @returns {Promise}
   * @fulfill {Item}
   * @reject {Error}
   */
  function getBoard(itemId, options) {
    options = options || {};
    const [, id] = decodeBoardId(itemId);
    return http.get(`${settings.apiUrl}/v3/boards/${id}`, null, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(response => ({
      ...response,
      data: toBoard(response.data)
    })).catch(toError);
  }
  return {
    get: getBoard
  };
}